import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@mui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@mui/material';

//import { getInitials } from 'helpers';
import { NavLink } from 'react-router-dom';
import { ListCard, ListCardField, ListCards } from 'components';
import useCompactLayout from 'hooks/useCompactLayout';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  textLink: {
		textDecoration: 'underline',
	},
}));

const CustomersTable = props => {
  const { className, customers, ...rest } = props;

  const classes = useStyles();
  const isCompact = useCompactLayout();

  const [selectedRestaurants, setSelectedRestaurants] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleSelectAll = event => {
    const { customers } = props;

    let selectedRestaurants;

    if (event.target.checked) {
      selectedRestaurants = customers.map(customer => customer.id);
    } else {
      selectedRestaurants = [];
    }

    setSelectedRestaurants(selectedRestaurants);
  };

  const handleSelectOne = (event, urlIdentifier) => {
    const selectedIndex = selectedRestaurants.indexOf(urlIdentifier);
    let newSelectedUsers = [];

    if (selectedIndex === -1) {
      newSelectedUsers = newSelectedUsers.concat(selectedRestaurants, urlIdentifier);
    } else if (selectedIndex === 0) {
      newSelectedUsers = newSelectedUsers.concat(selectedRestaurants.slice(1));
    } else if (selectedIndex === selectedRestaurants.length - 1) {
      newSelectedUsers = newSelectedUsers.concat(selectedRestaurants.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedUsers = newSelectedUsers.concat(
        selectedRestaurants.slice(0, selectedIndex),
        selectedRestaurants.slice(selectedIndex + 1)
      );
    }

    setSelectedRestaurants(newSelectedUsers);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };




  const customerList = customers || [];
  // One slice, shared by both layouts, so page state survives a resize.
  const pagedCustomers = customerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Firestore timestamps are missing on some legacy records.
  const createdAt = (customer) =>
    customer.createdAt && customer.createdAt._seconds
      ? moment(new Date(customer.createdAt._seconds * 1000)).format('DD/MM/YYYY HH:mm:ss')
      : '';

  const renderCards = () => (
    <ListCards count={customerList.length} noun="customer" empty="No customers to show.">
      {pagedCustomers.map(customer => (
        <ListCard
          key={customer.id}
          data-testid="customer-card"
          header={
            <>
              <Checkbox
                checked={selectedRestaurants.indexOf(customer.id) !== -1}
                color="primary"
                onChange={event => handleSelectOne(event, customer.id)}
                size="small"
                inputProps={{ 'aria-label': `select ${customer.name}` }}
              />
              <Typography variant="body1">{customer.name}</Typography>
            </>
          }
        >
          <ListCardField label="Phone" value={customer.phoneNumber} />
          <ListCardField label="Email" value={customer.email} />
          <ListCardField label="Created" value={createdAt(customer)} />
        </ListCard>
      ))}
    </ListCards>
  );

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        {isCompact ? renderCards() : (
        <PerfectScrollbar>
          <div className={classes.inner}>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRestaurants.length === customers.length}
                      color="primary"
                      indeterminate={
                        selectedRestaurants.length > 0 &&
                        selectedRestaurants.length < customers.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Created At</TableCell>
      
                </TableRow>
              </TableHead>
              <TableBody>
                {pagedCustomers.map(customer => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={customer.id}
                    selected={selectedRestaurants.indexOf(customer.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedRestaurants.indexOf(customer.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, customer.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                   
                          <Typography variant="body1">{customer.name}</Typography>
                           
                    </TableCell>
                    <TableCell>{customer.phoneNumber}</TableCell>
                    <TableCell>
                      {customer.email}
                    </TableCell>
                    <TableCell>{createdAt(customer)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={customerList.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

CustomersTable.propTypes = {
  className: PropTypes.string,
  customers: PropTypes.array.isRequired
};

export default CustomersTable;
